import React, { useState, useEffect } from 'react';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { useTranslation } from "react-i18next";
import cellActions from '../gridHL/cellActions.pure';
import "./gridSelectionHL.pure.css";
import { Pager } from '@progress/kendo-react-data-tools';


const GridSelectionHLPure = (props) => {
    const {
        skip, //Number pagination {0}
        take, //Number pagination {6}
        dataGrid, //Array information to grid
        filter, //True to filter grid
        onFilterChange, //Filter function to grid
        onSelectedItem, //Select information item grid
        sortable, // True to make it sortable
        sort, // sort settings
        onSortChange, // function to handle sort
        columnOne = true, //You need the frist column boolean, true active third column
        statusColumn,
        columnTwo, //You need the second column boolean, true active third column
        columnThree, //You need the third column boolean, true active third column
        columnFour, //True or false to active four column
        columnFive, //True or false to active five actions column
        columnSix, //True or false to active Six
        widthColumnOne, //width column 1
        widthColumnStatus,
        widthColumnTwo, //width column 2
        widthColumnThree, //width column 3
        widthColumnFour, //width column 4
        widthColumnFive, //width column 5
        widthColumnSix, //width column 6
        minResizableWidth1,
        minResizableWidthStatus,
        minResizableWidth2,
        minResizableWidth3,
        minResizableWidth4,
        minResizableWidth5,
        minResizableWidth6,
        titleRow1, //Header first column
        titleStatusColumn,
        titleRow2, //Header second column
        titleRow3, //Header third column
        titleRow4, // Header fourth column
        titleRow5, // Header five column
        titleRow6, // Header Six column
        headerColumnOne, //header´s style in column 1
        headerColumnStatus,
        headerColumnTwo, //header´s style in column 2
        headerColumnThree, //header´s style in column 3
        headerColumnFour, //header´s style in column 4
        headerColumnSix, //header´s style in column 6
        cellColumnOne, //cell for column 1
        cellColumnStatus,
        cellColumnTwo, //cell for column 2
        cellColumnThree, //cell for column 3
        cellColumnFour, //cell for column 4
        cellColumnSix, //cell for column 6
        headerColumnOneClass, // className for column 1
        headerColumnStatusClass,
        headerColumnTwoClass, // className for column 2
        headerColumnThreeClass, // className for column 3
        headerColumnFourClass, // className for column 4
        headerColumnFiveClass, // className for column 5 (Actions)
        columnFiveStyleClass, // styles for column 5
        headerColumnSixClass, // className for column 5 (Actions)
        pageable = true,
        styleGrid,
        setShowDetails, //True or false, show detail
        setNameComponentUser, //Name item actions, section
        iconOneActiveSelected, //Active one button item, True or false if you use value from array
        iconOneActive, //Active section/item actions, fisrt item action
        iconTwoActive, //Active section/item actions, second item action
        iconTwoActiveSelected, //Active one button item, True or false if you use value from array
        iconThirdActive, //Active section/item actions, third item action
        iconFourthActive, //Active section/item actions, four item action
        iconTrashActive, // Active trash icon
        disableFirst, // disable first action button
        disableTrash, // disable trash button
        labelOneActions, //Label fisrt item action
        labelTwoActions, //Label second item action
        labelTwoActions2, // Label second option text to action column
        labelThirdActions, //Label third item action
        labelFourthActions, //Label fourth item action
        labelFifthActions, //Label fifth item action
        labelTrashActions, //Label trash icon
        tooltipTrashIcon = 'Eliminar', // Trash icon tooltip text
        tooltipOneText, // Tooltip for first button
        activeDialog1, //True to function active dialog and false to change page
        btnOpenDialog1, //Function to open dialog in cellAction
        showDialogYesNo, //Value true or false, to dialog
        activeDialog2, //Function to open dialog on second btn in cellAction
        btnOpenDialog2, //Function to open dialog on second btn in cellAction
        showDialogYesNo2, //Value true or false, to dialog on second btn
        activeDialogTrash,
        btnOpenDialogTrash,
        showDialogYesNoTrash,
        paddingBtns, //True or false if want padding between btns
        onItemChange, // Function that updates data
        onRowClick,
        styleGeneral,
        styleGeneralClass,
        isCheckedColOne,
        onHeaderRowClick, //Function to click in month
        mobileFunction,
        fieldColumn2, //Name column 2
        fieldColumn3, //Name column 3
        fieldColumn4, //Name column 4
        fieldColumn6, //Name column 6
        filterableColumn1, //True or false. Column is filterbale(icon filter) or not
        filterableColumn2, //True or false. Column is filterbale(icon filter) or not
        filterableColumn3, //True or false. Column is filterbale(icon filter) or not
        filterableColumn4, //True or false. Column is filterbale(icon filter) or not
        filterableColumn5, //True or false. Column is filterbale(icon filter) or not
        filterableColumn6, //True or false. Column is filterbale(icon filter) or not
        filterCellColumn3, //Custom filter cell
        filterCellColumn4, //Custom filter cell
        filterCellColumn6, //Custom filter cell
        noRecordsMessage,
        hasLockedColumns = false,
        iconFifth,
        iconFifthActive
    } = props;

    const { t } = useTranslation();

    const initialDataState = {
        skip,
        take,
    };

    const gridColumnNoRecordsStyle = {
        color: "#2C353C",
        fontSize: "16px",
        fontWeight: 550,
        fontFamily: "Quicksand",
    };


    const [page, setPage] = useState(initialDataState);
    const [selectedItem, setSelectedItem] = useState({});

    const onPageChange = (event) => {
        setPage(event.page);
    };

    const onPageChangePager = (e) => {
        setPage({
            skip: e.skip,
            take: e.take,
        });
    };

    useEffect(() => {
        if (!columnFive) return;
        onSelectedItem(selectedItem);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem]);

    useEffect(() => {
        setPage(initialDataState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid]);

    const pagerSettings = {
        info: true,
        buttonCount: 5,
        type: "numeric",
        previousNext: true,
    }

    return <>
        <Grid
            {...props}
            className={styleGeneral === true ? styleGeneralClass : "gridSelectionHLPure"}
            data={(pageable === false) ? dataGrid : dataGrid.slice(page.skip, page.take + page.skip)}
            reorderable
            style={styleGrid}
            skip={hasLockedColumns ? null : page.skip}
            take={hasLockedColumns ? null : page.take}
            pageable={pageable && !hasLockedColumns ? pagerSettings : null}
            total={dataGrid.length}
            onPageChange={hasLockedColumns ? null : onPageChange}
            filter={filter}
            onChangeFilter={onFilterChange}
            onItemChange={onItemChange}
            onRowClick={onRowClick}
            onHeaderRowClick={onHeaderRowClick}
            sortable={sortable}
            sort={sort}
            onSortChange={onSortChange}
        >
            {
                columnOne ?
                    <GridColumn
                        width={widthColumnOne}
                        title={titleRow1}
                        cell={cellColumnOne}
                        headerCell={headerColumnOne}
                        headerClassName={headerColumnOneClass}
                        field={isCheckedColOne}
                        filterable={filterableColumn1}
                        locked={props.lockedColumnOne}
                        minResizableWidth={minResizableWidth1}
                    /> : null
            }
            {
                statusColumn && <GridColumn
                    title={titleStatusColumn}
                    width={widthColumnStatus}
                    cell={cellColumnStatus}
                    headerCell={headerColumnStatus}
                    headerClassName={headerColumnStatusClass}
                    minResizableWidth={minResizableWidthStatus}
                />
            }
            {columnTwo ?
                <GridColumn
                    title={titleRow2}
                    width={widthColumnTwo}
                    cell={cellColumnTwo}
                    headerCell={headerColumnTwo}
                    headerClassName={headerColumnTwoClass}
                    field={fieldColumn2}
                    filterable={filterableColumn2}
                    minResizableWidth={minResizableWidth2}
                />
                : ""
            }
            {
                columnThree ?
                    <GridColumn
                        title={titleRow3}
                        cell={cellColumnThree}
                        headerCell={headerColumnThree}
                        headerClassName={headerColumnThreeClass}
                        width={widthColumnThree}
                        field={fieldColumn3}
                        filterable={filterableColumn3}
                        filterCell={filterCellColumn3}
                        minResizableWidth={minResizableWidth3}
                    />
                    : ""
            }
            {
                columnFour ?
                    <GridColumn
                        title={titleRow4}
                        cell={cellColumnFour}
                        headerCell={headerColumnFour}
                        headerClassName={headerColumnFourClass}
                        width={widthColumnFour}
                        field={fieldColumn4}
                        filterable={filterableColumn4}
                        filterCell={filterCellColumn4}
                        minResizableWidth={minResizableWidth4}
                    />
                    : ""
            }
            {
                columnFive ?
                    <GridColumn
                        filterable={filterableColumn5}
                        title={titleRow5}
                        cell={cellActions({
                            setSelectedItem: setSelectedItem,
                            props,
                            setShowDetails: setShowDetails,
                            setNameComponentUser: setNameComponentUser,
                            iconOneActiveSelected,
                            iconOneActive,
                            iconTwoActive,
                            iconTwoActiveSelected,
                            iconThirdActive,
                            iconFourthActive,
                            iconTrashActive,
                            disableFirst,
                            disableTrash,
                            labelOneActions,
                            labelTwoActions,
                            labelTwoActions2,
                            labelThirdActions,
                            labelFourthActions,
                            labelFifthActions,
                            labelTrashActions,
                            activeDialog1,
                            btnOpenDialog1,
                            showDialogYesNo,
                            activeDialog2,
                            btnOpenDialog2,
                            showDialogYesNo2,
                            paddingBtns,
                            mobileFunction,
                            tooltipTrashIcon,
                            tooltipFirstText: tooltipOneText,
                            activeDialogTrash,
                            btnOpenDialogTrash,
                            showDialogYesNoTrash,
                            styleCol4: columnFiveStyleClass,
                            isLocked: props.lockedColumnFive,
                            iconFifthActive,
                            iconFifth
                        })}
                        width={widthColumnFive}
                        locked={props.lockedColumnFive}
                        headerClassName={headerColumnFiveClass}
                        minResizableWidth={minResizableWidth5}
                    />
                    : ""
            }
            {
                columnSix ?
                    <GridColumn
                        title={titleRow6}
                        cell={cellColumnSix}
                        headerCell={headerColumnSix}
                        headerClassName={headerColumnSixClass}
                        width={widthColumnSix}
                        field={fieldColumn6}
                        filterable={filterableColumn6}
                        filterCell={filterCellColumn6}
                        minResizableWidth={minResizableWidth6}
                    />
                    : ""
            }
            <GridNoRecords>
                <span style={gridColumnNoRecordsStyle}>
                    {noRecordsMessage ? noRecordsMessage : t("configurationDomainPanel.notResults")}
                </span>
            </GridNoRecords>
        </Grid>

        {
            hasLockedColumns && <Pager
                skip={page.skip}
                take={page.take}
                onPageChange={onPageChangePager}
                total={dataGrid.length}
                info
                buttonCount={5}
                type='numeric'
                previousNext
            />
        }
    </>;
};
export { GridSelectionHLPure as default };